module.exports = __webpack_public_path__ + "static/media/oauth_api.fa1ebc68.md";